import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { usePaginatedQuery } from '@sorare/core/src/hooks/graphql/usePaginatedQuery';

import { UserList } from '../UserList';
import { UserNetwork } from '../UserNetwork';
import type {
  NetworkFollowersQuery,
  NetworkFollowersQueryVariables,
} from './__generated__/index.graphql';

const NETWORK_FOLLOWERS_QUERY = gql`
  query NetworkFollowersQuery($slug: String!, $after: String) {
    user(slug: $slug) {
      slug
      followers(first: 18, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          slug
          ...UserNetwork_user
        }
      }
    }
  }
  ${UserNetwork.fragments.user}
` as TypedDocumentNode<NetworkFollowersQuery, NetworkFollowersQueryVariables>;

type Props = {
  user: {
    slug: string;
  };
};

export const Followers = ({ user }: Props) => {
  const { loading, data, loadMore } = usePaginatedQuery(
    NETWORK_FOLLOWERS_QUERY,
    {
      variables: { slug: user.slug },
      connection: 'UserWithSubscriptionSlugConnection',
    }
  );

  const load = () => {
    loadMore(false, {
      after: data?.user?.followers.pageInfo.endCursor,
      slug: user.slug,
    });
  };

  return (
    <UserList
      users={data?.user?.followers.nodes || []}
      renderUser={u => <UserNetwork key={u.slug} user={u} />}
      loading={loading}
      loadMore={load}
      hasNextPage={data?.user?.followers.pageInfo.hasNextPage || false}
    />
  );
};
